// removed by extract-text-webpack-plugin
module.exports = {"root":"LatestBulletins-module-root-3aufx","section":"LatestBulletins-module-section-2_y4m","listing":"LatestBulletins-module-listing-3Z-2W","section-title":"LatestBulletins-module-section-title-16GHz","sectionTitle":"LatestBulletins-module-section-title-16GHz","icon-arrow":"LatestBulletins-module-icon-arrow-3E69d","iconArrow":"LatestBulletins-module-icon-arrow-3E69d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LatestBulletins/LatestBulletins.module.scss
// module id = 1114
// module chunks = 0